import { lazy, type ReactElement } from "react";
import { type RouteProps } from "react-router";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";
import { TitleRoute } from "../../Common/Routing/TitleRoute";

const TrashedItems = lazy(() => import("../TrashedItems/TrashedItems"));
const MailLog = lazy(() => import("../MailLog/MailLog"));
const FuturePrices = lazy(() => import("./FuturePrices/FuturePrices"));
const FutureCosts = lazy(() => import("./FutureCosts/FutureCosts"));
const VendorConnections = lazy(() => import("./VendorConnections/VendorConnections"));
const VendorConnectionModify = lazy(() => import("./VendorConnections/VendorConnectionModify"));
const HostConnections = lazy(() => import("./HostConnections/HostConnections"));
const HostConnectionModify = lazy(() => import("./HostConnections/HostConnectionModify"));
const HostView = lazy(() => import("./HostConnections/Changes/HostView"));
const Barcodes = lazy(() => import("./Barcodes/Barcodes"));
const ProductUtilities = lazy(() => import("./Products/ProductUtilities"));
const CustomerUtilities = lazy(() => import("./Customers/CustomerUtilities"));

export default function UtilitiesIndex(): Array<ReactElement<RouteProps>> {
    return [
        <TitleRoute
            title="Trashed Items | Shopfront"
            path="/utilities/trashed-items"
            key="trashed-items"
            element={<TrashedItems />}
        />,
        <TitleRoute
            title="Mail Log | Shopfront"
            path="/utilities/mail-log"
            key="mail-log"
            element={<MailLog />}
        />,
        <TitleRoute
            title="Future Prices | Shopfront"
            path="/utilities/future-prices"
            key="future-prices"
            element={<FuturePrices />}
        />,
        <TitleRoute
            title="Vendor Connections | Shopfront"
            path="/utilities/vendor-connections"
            key="vendor-connections"
            element={<VendorConnections />}
        />,
        <TitleRoute
            title="Modify Vendor Connection | Shopfront"
            path="/utilities/vendor-connection/:id"
            key="vendor-connections-modify"
            element={<InjectRouteParams route={VendorConnectionModify} />}
        />,
        <TitleRoute
            title="Future Costs | Shopfront"
            path="/utilities/future-costs"
            key="future-costs"
            element={<FutureCosts />}
        />,
        <PermissionRoute
            title="Host Connections | Shopfront"
            path="/utilities/host-connections"
            key="host-connections"
            element={<HostConnections />}
            permissions={[ "see_host_connections" ]}
        />,
        <PermissionRoute
            title="Create Host Connection | Shopfront"
            path="/utilities/host-connection/new"
            key="host-connection-create"
            element={<HostConnectionModify />}
            permissions={[ "modify_host_connections" ]}
        />,
        <PermissionRoute
            title="Modify Host Connection | Shopfront"
            path="/utilities/host-connection/:id"
            key="host-connection-modify"
            element={<HostConnectionModify />}
            permissions={[ "modify_host_connections" ]}
        />,
        <PermissionRoute
            title="View Host | Shopfront"
            path="/utilities/host-connection/:id/changes"
            key="host-connection-changes"
            element={<HostView />}
            permissions={[ "see_host_changes" ]}
        />,
        <TitleRoute
            title="Barcodes | Shopfront"
            path="/utilities/barcodes"
            key="barcodes"
            element={<Barcodes />}
        />,
        <TitleRoute
            title="Product Utilities | Shopfront"
            path="/utilities/products"
            key="product-utilities"
            element={<ProductUtilities />}
        />,
        <TitleRoute
            title="Customer Utilities | Shopfront"
            path="/utilities/customers"
            key="customer-utilities"
            element={<CustomerUtilities />}
        />,
    ];
}
